import React, { forwardRef, useState } from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import colors from "../../theme";

const MiniStatistics = forwardRef((props, ref) => {
  const [clientHeight] = useState(window.innerHeight);
  const { name, value, icon } = props;

  return (
    <Box sx={{ backgroundColor: colors.mainContentBgColor }}>
      <Card
        ref={ref}
        sx={{
          backgroundColor: colors.mainContentBgColor,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: clientHeight > 500 ? 120: 100,
          py: clientHeight > 500 ? 1 : 0,
          my: clientHeight > 500 ? 1 : 0
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            py: 1
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              sx={{
                textAlign: "center",
                color: colors.primary,
              }}
            >
              {icon}
            </Grid>
            <Grid
              item
              xs={12}
              my={0.5}
              sx={{
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: clientHeight > 500 ? "13px": "10px" }}>{name}</Typography>
            </Grid>
            <Grid
              item
              xs={12}
              color="black"
              sx={{
                textAlign: "center",
              }}
            >
              <Typography sx={{ typography: 'h6', fontSize: clientHeight > 500 ? "17px": "12px"}}>
                {value}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
});

export default MiniStatistics;
